import React from 'react';
import { PopularTrainsListProps } from './PopularTrainsList.types';
import { getAppEnv } from '../../../../../../../config/env';
import { IMAGE_ALT_TEXT, LABELS } from '../../../../constants/LTSConstants';
import { TrainDetail } from '../../../../types/LTSTypes';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const PopularTrainsList = (props: PopularTrainsListProps) => {
  const { trainList, onClick } = props;

  const handleOnClick = (trainDetail: TrainDetail) => {
    onClick(trainDetail);
  };

  return (
    <div className="LTSTrainNumber-PopularTrainsList-wrapper">
      <div className="LTSTrainNumber-PopularTrainsList-header">
        <img src={`${PUBLIC_URL}/static/public/popular_ic.webp`} alt={IMAGE_ALT_TEXT.circleWithStarInCenter} />
        <span>{LABELS.POPULAR_TRAINS}</span>
      </div>
      <ul className="LTSPageCommon-ul">
        {trainList.map((item, index) => (
          <li
            className="LTSPageCommon-li LTSTrainNumber-PopularTrainsList-li LTSPageCommon-click-transition"
            key={`${item.trainNumber}-${index}`}
            onClick={() => handleOnClick(item)}
          >
            <span>{item.trainNumber}</span>
            <span className="LTSPageCommon-text-overflow-ellipsis">{item.trainName}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PopularTrainsList;
